import React from "react";
import { Box, Typography, Avatar, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";
import "../styles/Testimonials.css";

const testimonials = [
  {
    name: "Mr Rajashekar",
    text: "Building my house was my dream, and RM Infra made it come true with an amazing plan and service.",
    img: "https://via.placeholder.com/80",
  },
  {
    name: "Mr shashank Paul",
    text: "Highly professional & creative team. The results exceeded expectations! They paid great attention to every detail.",
    img: "https://via.placeholder.com/80",
  },
  {
    name: "Mr Bilal",
    text: "Excellent communication, no delays, and superb quality. RM Infra ensured full transparency and top-notch execution!",
    img: "https://via.placeholder.com/80",
  },
  {
    name: "Mr Ravichandra",
    text: "RM Infra turned my vision into a beautiful reality with incredible craftsmanship and professionalism.",
    img: "https://via.placeholder.com/80",
  },
  {
    name: "Mr Darshan",
    text: "They handled everything perfectly — from design to finishing, every detail was done with care.",
    img: "https://via.placeholder.com/80",
  },
];

const Testimonials = () => {
  // Duplicate list to create infinite loop
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <Box
      sx={{
        py: 10,
        background: "linear-gradient(180deg, #f8fbff 0%, #e3f2fd 100%)",
        overflow: "hidden",
      }}
    >
      <Typography
        variant="h4"
        fontWeight={700}
        mb={1}
        textAlign="center"
        color="primary"
      >
        What Our Clients Say
      </Typography>

      <Typography
        variant="subtitle1"
        textAlign="center"
        color="text.secondary"
        mb={6}
      >
        Hear from homeowners who trusted us with their dream projects.
      </Typography>

      {/* ===== Infinite Horizontal Slider ===== */}
      <Box sx={{ overflow: "hidden", whiteSpace: "nowrap", width: "100%" }}>
        <motion.div
          className="testimonial-slider"
          style={{
            display: "inline-flex",
            gap: "30px",
          }}
          animate={{
            x: ["0%", "-50%"], // scroll left halfway (since duplicated)
          }}
          transition={{
            duration: 40, // slower for smoothness
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {duplicatedTestimonials.map((item, index) => (
            <Card
              key={index}
              sx={{
                minWidth: 350,
                borderRadius: 3,
                p: 3,
                flexShrink: 0,
                boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                backgroundColor: "#fff",
              }}
            >
              <Box display="flex" alignItems="center" mb={2}>
                <Avatar
                  src={item.img}
                  alt={item.name}
                  sx={{ width: 60, height: 60, mr: 2 }}
                />
                <Typography variant="h6" fontWeight={600}>
                  {item.name}
                </Typography>
              </Box>
              <CardContent sx={{ pt: 0 }}>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontStyle="italic"
                  lineHeight={1.7}
                >
                  “{item.text}”
                </Typography>
              </CardContent>
            </Card>
          ))}
        </motion.div>
      </Box>
    </Box>
  );
};

export default Testimonials;
